// extracted by mini-css-extract-plugin
module.exports = {"modal":"index__modal___c8SFw","inline":"index__inline___23vMg"};